import { DEFAULT_PAGE_SIZE } from 'shared/constants/pagination';

export const calculatePaginatedRows = <T>(
    page: number,
    list: T[],
    pageLimit?: number,
): T[] => {
    const limit = pageLimit || DEFAULT_PAGE_SIZE;
    const skip = (page - 1) * limit;
    return list.slice(skip, page * limit);
};
